var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "matrix(-1 0 0 1 18 0)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_946_966",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_946_966",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAAAXNSR0IArs4c6QAABCxJREFUeF7t3T2IFVcUB/D/nbcvJk3UaCCSOoi2EnEhZUAUknQpxA8sljdzd0FDEO3cypgQVnmwc2chZDFo87BK1MYiCSlULKzE0sbCAZ+gQljEnSODIwh+MOepZ+653KnP3fvmN2fvzn/ezKxB3EQEjMgscRJEaKEmiNARWkhAaJrY0RFaSEBomtjREVpIQGga0Y4eDodr+v3+TwD2A9jwmn28A+BMWZbz8/PzT4Qc3vs0otDOuQUAP7Tcq3NZlu1tWet9mTT0vTd08ktYRHTMWvuz94otPqDX0AAqY8w3aZpearEvXpeIQhdFcYqIDjNFHlRVNT07O3uLOc6rclHo5eXlD1dWVv4FsJ2jQES3e73e9sFgUC89KjdR6FpoaWlpU1VV1wF8zhS7XJblbq1nIuLQNW6e59uMMf8B+IiDTUQL1tofOWN8qe0Eut5559w+AH9wIYhoxlr7G3dc1/WdQTfYnPPq51aPiehra239G6Fm6xR6NBr1xuPxnwB2M8XuTk1NfTkzM1OnSBVbp9C10HA4/Ljf718BsJUpdiNJkq8Gg8H/zHGdlHcO3fxx3JwkyVUiWsdUOJ+m6ffGGGKOEy/3ArpZr3cCuAigx1HQEtO9gW46+6gx5iQHuo7pAL7LsuwCc5xouVfQ9Z4XRfE7ER1kKjxaXV2dnpubu8kcJ1buHXSoMd076LrFQozpXkI363VQMd1b6OZMJJiY7jV0SDHde+hQYrr30KHEdBXQIcR0NdDaY7oqaM0xXR201piuElpjTFcJrTGmq4Vu1usdxph/AKzhXIbr4tt01dCaYrp6aC0xPQhoDTE9COhmvV5vjLkG4AvOeg1A5Nv0YKBr3MXFxS1JktS3LqzlYBPRr9baI5wx3NqgoN8ipt/LsuxTLh6nPkI/0yqzLPuMA8etDQo6Lh3cwz9BfZ7n8Y/hBG6sIfH0jsU1efGEz8aI3v6rfo0uimI/EZ3hHibpG9pVQxdFMU1Ef8eLStw2Y9Rru5tJZUfHC/+Mjpy0lIhMURRnAexh/oxO7zhV19HOuWMA6jckcLbO76FWBe2cm+ipAABHsyz7hXNk3nWtGug8zzc3l0FZV+YAePGciwpo3+N1m+73HrqJ138B2NVmh16o8epZRO+hNcTrNg3gNbSWeK0aWlO8VgutLV6rhNYYr9VBa43X6qC1xmtV0JrjtRpo7fFaBXQI8dp76FDitffQocRrr6FDitfeQocWr72EDjFeewcdarz2Dto5dxrAoTYf7IWah1VV7YivNWaoOefGAD5hDKmI6Ftrbf2aNtWb6IV/51x89bxEu3D/mUKapvs0vKWxjZ1oR49Gow/G4/EJAAcAbHzNB7xfv/6uLMvjWl/K/ar9EoVuc+RDrYnQQkc2QkdoIQGhaWJHR2ghAaFpYkdHaCEBoWliRwtBPwWyjIt51Vw22AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/Chevron Left.0a273e50a294ccc23c6ef16424066ee2.svg";
export { ForwardRef as ReactComponent };